module.exports = __webpack_public_path__ + "static/img/wechatcode.d254962.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wechatcode.jpg
// module id = b+iz
// module chunks = 26